import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "buttons-for-offer-view" }
const _hoisted_2 = {
  key: 0,
  class: "status green"
}
const _hoisted_3 = {
  key: 1,
  class: "status red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_offer_button = _resolveComponent("offer-button")!
  const _component_confirmation_popup = _resolveComponent("confirmation-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_offer_button, {
        class: "download-pdf btn",
        icon: "get_app",
        text: _ctx.downloadPDF,
        color: "var(--primary-color)",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadPdf()))
      }, null, 8 /* PROPS */, ["text"]),
      (_ctx.offerAccepted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.offerIsAccepted), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_ctx.offerRejected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.offerIsRejected), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _withDirectives(_createVNode(_component_offer_button, {
        class: "reject-offer btn",
        icon: "clear",
        text: _ctx.rejectOffer,
        color: "var(--red)",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rejectClicked(_ctx.rejectOfferMessage, _ctx.reject)))
      }, null, 8 /* PROPS */, ["text"]), [
        [_vShow, !_ctx.offerAccepted && !_ctx.offerRejected && _ctx.siteIsInitialized]
      ]),
      _withDirectives(_createVNode(_component_offer_button, {
        class: "accept-offer btn",
        icon: "done",
        text: _ctx.acceptOffer,
        color: "var(--green)",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.acceptClicked(_ctx.acceptOfferMessage, _ctx.accept)))
      }, null, 8 /* PROPS */, ["text"]), [
        [_vShow, !_ctx.offerAccepted && !_ctx.offerRejected && _ctx.siteIsInitialized]
      ])
    ]),
    _withDirectives(_createVNode(_component_confirmation_popup, {
      message: _ctx.popupMsg,
      btnText: _ctx.confirmBtnText,
      btnColor: _ctx.btnColor,
      isAcceptPopup: _ctx.isAcceptPopup,
      onCloseMe: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPopup = false))
    }, null, 8 /* PROPS */, ["message", "btnText", "btnColor", "isAcceptPopup"]), [
      [_vShow, _ctx.showPopup]
    ])
  ], 64 /* STABLE_FRAGMENT */))
}